var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosicao2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 93,
    viewBox: "0 0 86 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 58.8418,
    width: 86,
    height: 34,
    fill: "url(#paint0_linear_342_28027)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5879 11.4331L30.9664 15.4108L25 3.9786L32.6215 0.000976562L38.5879 11.4331Z",
    fill: "#5C1526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5977 12.9937L34.1475 13.7505L28.1811 2.31835L29.6312 1.56152L35.5977 12.9937Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5879 11.4336L56.2093 15.4112L62.1758 3.97905L54.5543 0.00142097L48.5879 11.4336Z",
    fill: "#5C1526"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5781 12.9941L53.0283 13.751L58.9947 2.3188L57.5446 1.56197L51.5781 12.9941Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7455 28.8728C60.7455 38.7436 52.7436 46.7455 42.8727 46.7455C33.0019 46.7455 25 38.7436 25 28.8728C25 19.002 33.0019 11.0001 42.8727 11.0001C52.7436 11.0001 60.7455 19.002 60.7455 28.8728Z",
    fill: "url(#paint1_linear_342_28027)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7455 28.8728C62.7455 39.8482 53.8481 48.7455 42.8727 48.7455C31.8973 48.7455 23 39.8482 23 28.8728C23 17.8974 31.8973 9.00009 42.8727 9.00009C53.8481 9.00009 62.7455 17.8974 62.7455 28.8728ZM42.8727 46.7455C52.7436 46.7455 60.7455 38.7436 60.7455 28.8728C60.7455 19.002 52.7436 11.0001 42.8727 11.0001C33.0019 11.0001 25 19.002 25 28.8728C25 38.7436 33.0019 46.7455 42.8727 46.7455Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8727 44.7455C51.639 44.7455 58.7454 37.6391 58.7454 28.8728C58.7454 20.1065 51.639 13.0001 42.8727 13.0001C34.1064 13.0001 27 20.1065 27 28.8728C27 37.6391 34.1064 44.7455 42.8727 44.7455ZM42.8727 46.7455C52.7436 46.7455 60.7455 38.7436 60.7455 28.8728C60.7455 19.002 52.7436 11.0001 42.8727 11.0001C33.0019 11.0001 25 19.002 25 28.8728C25 38.7436 33.0019 46.7455 42.8727 46.7455Z",
    fill: "#B2B2B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2471 33.4366V35.3575H39.9991V34.6603C39.9991 33.8764 40.1267 33.1222 40.3819 32.3976C40.6416 31.6729 40.9538 31.0486 41.3184 30.5245C41.683 29.9959 42.0453 29.4991 42.4053 29.0343C42.7699 28.5649 43.0798 28.1 43.335 27.6397C43.5948 27.1749 43.7246 26.742 43.7246 26.3409V24.7208C43.7246 24.2058 43.5196 23.9483 43.1094 23.9483C42.9134 23.9483 42.7539 24.0167 42.6309 24.1534C42.5124 24.2856 42.4532 24.4793 42.4532 24.7345V26.9835H40.1153V24.7481C40.1153 23.9005 40.3841 23.2306 40.9219 22.7384C41.4642 22.2462 42.2435 22.0001 43.2598 22.0001C44.1576 22.0001 44.864 22.2234 45.3789 22.67C45.8985 23.1121 46.1582 23.7068 46.1582 24.4542V25.9376C46.1582 26.5255 46.042 27.1248 45.8096 27.7354C45.5772 28.3461 45.2923 28.9044 44.9551 29.4103C44.6224 29.9116 44.2875 30.3992 43.9502 30.8731C43.613 31.3425 43.3282 31.8028 43.0957 32.254C42.8633 32.7006 42.7471 33.0948 42.7471 33.4366H46.2471Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_342_28027",
    x1: 43,
    y1: 58.8418,
    x2: 43,
    y2: 92.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F1221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_342_28027",
    x1: 42.8727,
    y1: 0.000976563,
    x2: 42.8727,
    y2: 48.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosicao2);
export default __webpack_public_path__ + "static/media/posicao-2.78d5a1307630706c77652e7408a3c5fa.svg";
export { ForwardRef as ReactComponent };